var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1024 1024"}},[_c('path',{attrs:{"d":"m466.745 658.746-165.49-165.491C260.937 452.937 289.492 384 346.509 384h330.982c57.018 0 85.574 68.937 45.254 109.255L557.254 658.746c-24.994 24.992-65.516 24.992-90.51 0z"}})])
}
var staticRenderFns = []

export default { render: render }